import { GlSprintf, GlLink } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import TimeAgoTooltip from '../../vue_shared/components/time_ago_tooltip.vue?vue3';
import { EDITED_TEXT } from '../i18n';
export default {
    name: 'EditedNoteText',
    components: {
        GlSprintf,
        GlLink,
        TimeAgoTooltip
    },
    props: {
        actionText: {
            type: String,
            required: true
        },
        actionDetailText: {
            type: String,
            required: false,
            default: ''
        },
        editedAt: {
            type: String,
            required: false,
            default: null
        },
        editedBy: {
            type: Object,
            required: false,
            default: null
        },
        className: {
            type: String,
            required: false,
            default: 'edited-text'
        }
    },
    i18n: EDITED_TEXT
};
